import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tile"]

  select(event) {
    this.tileTargets.forEach(tile => {
      tile.classList.remove("border-cyan-500", "bg-cyan-500/5")
      tile.classList.add("border-gray-700/50")
    })
    const label = event.target.closest("label")
    if (label) {
      label.classList.add("border-cyan-500", "bg-cyan-500/5")
      label.classList.remove("border-gray-700/50")
    }
  }
}
